// Small logger that replaces ad-hoc console.* calls.
//
// In production (LOG_LEVEL=warn by default) ``info`` and ``debug`` are no-ops,
// so the bundle stays quiet without having to strip every call site.
import { LOG_LEVEL } from './config';

const LEVELS = { debug: 10, info: 20, warn: 30, error: 40, silent: 50 };
const threshold = LEVELS[LOG_LEVEL] ?? LEVELS.warn;

function emit(level, args) {
  if ((LEVELS[level] ?? 0) < threshold) return;
  const method = level === 'debug' ? 'log' : level;
  console[method](`[${level}]`, ...args);
}

export const logger = {
  debug: (...args) => emit('debug', args),
  info: (...args) => emit('info', args),
  warn: (...args) => emit('warn', args),
  error: (...args) => emit('error', args),
};
